import React from 'react';
import Menu from '@material-ui/core/Menu';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { ThemeProvider } from '@material-ui/styles';
import { NavLink } from 'react-router-dom';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';
import BCLMenuIconTheme from './BCLIconLabelButtonTheme';

const useStyles = makeStyles(theme => ({
  topNavLink: {
    color: props => `rgb(${props.configColors['--color_55']})`,
    padding: '10px 20px',
    textDecoration: 'none',
    flexDirection: 'row',
    fontSize: '14px',
    lineHeight: '24px',
    '&:hover': {
      backgroundColor: props => `rgb(${props.configColors['--color_1']})`,
      color: props => `rgb(${props.configColors['--color_54']})`
    }
  },
  topNavLinkActive:{
    backgroundColor: props => `rgb(${props.configColors['--color_1']})`,
    color: props => `rgb(${props.configColors['--color_54']})`
  },
  hamburgerMenuIcon: {
    fontSize: '2.3rem',
    color: props => `rgb(${props.configColors['--color_1']})`
  }
}));

const MenuLink = React.forwardRef((props, ref) => <NavLink innerRef={ref} {...props} />);

export default function BCLNavMenu(props) {
  const classes = useStyles(props);

  const [anchorEl, setAnchorEl] = React.useState(null);

  function handleClick(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  function getRightPositionOfTopMenu() {
    let rightPosition = (window.screen.width <= 768 ) ? window.screen.width : (window.screen.width - 270);
    return rightPosition;
  }

  return (
    <div>
      <IconButton aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
        <ThemeProvider theme={BCLMenuIconTheme}>
          <MenuIcon className={classes.hamburgerMenuIcon} />
        </ThemeProvider>
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorPosition={{top:70, left:getRightPositionOfTopMenu()}}
        anchorReference={'anchorPosition'}
        MenuListProps={{ disablePadding: true }}
        classes={{list: "nav-menu-list", paper: "nav-menu-container"}}
      >
      {props.itemList.map((item, index) =>(
          <MenuItem key={index} component={MenuLink} to={item.to} onClick={handleClose} activeClassName={classes.topNavLinkActive} className={classes.topNavLink}>
          <span className = {item.icon}/>
            {item.name}
          </MenuItem>
      ))}
      </Menu>
    </div>
  );
}
